import React from "react";
import PlansGrid from "./PlansGrid";

const CurrentPlans = ({ data }) => {
	return (
		<>
			<div className="my-5">
				{data.mainBodyText}
				{data.groups ? (
					data.groups.map(group => (
						<div key={group.id}>
							{group.title}
							{group.body}
							{group.docs.length > 0 ? (
								<PlansGrid plans={group.docs} />
							) : null}
						</div>
					))
				) : (
					<div></div>
				)}
			</div>
		</>
	);
};

export default CurrentPlans;
